import { TabItems } from "@components/common";
import { Route, Routes } from "react-router-dom";

import { PermissionsRoles } from "./permissions-roles";
import { PermissionsUsers } from "./permissions-users";

export enum ResponsibilityRequestTypeEnum {
  RESPONSIBILITY = "RESPONSIBILITY",
  LEGAL_INFORMATION = "LEGAL_INFORMATION",
}

const Permissions: React.FC = () => {
  const TAB_ITEMS: { label: string; path: string; exact?: boolean }[] = [
    { label: "Роли", path: "/permissions", exact: true },
    { label: "Пользователи", path: "/permissions/users", exact: true },
  ];

  return (
    <main className="content-container">
      <div className="content-section">
        <div className="tab-section">
          <div className="tab-cont">
            <TabItems items={TAB_ITEMS} />
            <div className="tab-content-items">
              <Routes>
                <Route path="/permissions" Component={PermissionsRoles} />
                <Route path="/permissions/users" Component={PermissionsUsers} />
              </Routes>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Permissions;
